<template>
  <div class="d-flex col-sm-12">
    <div class="text-center me-3">
      <v-btn elevation="0" size="35" height="35" :style="'background:' + colorBorder + '; color:white; padding: 2px;'">
        <span style="font-size: 7px; font-weight: bold; line-height: 1.1; display: flex; flex-direction: column;">
          <span v-if="user === 'ChatSO'">Chat<br>SO</span>
          <span v-else>{{ user }}</span>
        </span>
      </v-btn>
    </div>
    
    <div class="flex-grow-1 textMsg" :style="'background:' +
      color +
      '; border-left: 0.25rem solid ' +
      colorBorder +
      '!important;'
      " v-html="renderedMarkdown">
    </div>
  </div>
</template>


<script setup>

import { computed } from 'vue'
import MarkdownIt from 'markdown-it'

const props = defineProps({
  user: {type: String, default: 'ChatSO'},
  message: String,
  color: String,
  colorBorder: String
});

// Configure markdown-it with linkify enabled
const md = new MarkdownIt({
  // html: false — CRITICAL for XSS prevention. The message text is a stored
  // question/answer rendered via v-html; html:true would pass raw markup such
  // as <img src=x onerror=alert()> straight into the DOM and execute it.
  // With html:false markdown-it escapes raw HTML to literal text while still
  // rendering real markdown (bold, lists, links, line breaks).
  html: false,
  linkify: true,  // Automatically convert URL-like text to links
  breaks: true,
  typographer: true
});

// Ensure linkify is properly configured
md.linkify.set({ fuzzyEmail: false });

// Override default link renderer to add target="_blank"
const defaultRender = md.renderer.rules.link_open || function(tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options);
};

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  // Add target="_blank" and rel="noopener noreferrer" to all links
  const aIndex = tokens[idx].attrIndex('target');
  if (aIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']);
    tokens[idx].attrPush(['rel', 'noopener noreferrer']);
  } else {
    tokens[idx].attrs[aIndex][1] = '_blank';
  }
  return defaultRender(tokens, idx, options, env, self);
};

// Render markdown
const renderedMarkdown = computed(() => {
  return md.render(props.message || '');
});

</script>


<style>
.textMsg {
  padding: 1.25rem;
  box-shadow: none !important;
}
.textMsg p {
  margin: 0.4rem 0;
}
.textMsg ul, .textMsg ol {
  padding-left: 1.5rem;
  margin: 0.4rem 0;
}
.textMsg li {
  margin: 0.2rem 0;
}
.textMsg a {
  color: #1565c0;
  word-break: break-all;
}
</style>
